<template>
  <div class="jin-form-grade">
    <el-form v-for="(form, i) in info.formList" :ref="(info.template + i)" :key="i" class="el-form-flex el-form-reduce" :model="form" :rules="info.rules">
      <Delete :fix-con="{type: 'online', tem: info, idx: i}" />
      <div class="title jin-m">
        <h3>等级经历</h3>
      </div>
      <Input v-model="form.certificate_name" label="证书名称" prop="certificate_name" />
      <Date v-model="form.get_time" :is-rang="false" label="获得时间" prop="get_time" />
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
    }
  },
  methods: {
    submitForm() {
      const status = []
      let curr = true
      this.info.formList.forEach((item, i) => {
        this.$refs[(this.info.template + i)][0].validate((valid) => {
          status.push(valid)
          if (status.length === this.info.formList.length) curr = status.every(item => item)
        })
      })
      return curr
    },
    resetForm() {
      this.info.formList.forEach((item, i) => {
        this.$refs[(this.info.template + i)][0].resetFields()
      })
      this.info.formList = []
    }
  }
}
</script>

